<template>
  <div class="container" style="padding-top: 8rem;">
    <img src="@/assets/amite-logo.jpg" alt="Amite Logo" class="logo" :class="{ visible: logoVisible }">
    <button class="shop-button" :class="{ visible: buttonVisible }" @click="goToShop">View products</button>
    <div class="social">
      <a href="https://instagram.com/amite.clo" target="_blank" class="instagram" :class="{ visible: socialVisible }">
        <i class="fab fa-instagram"></i>
      </a>
      <a href="https://tiktok.com/@amite.clo" target="_blank" class="tiktok" :class="{ visible: socialVisible }">
        <i class="fab fa-tiktok"></i>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data() {
    return {
      logoVisible: false,
      buttonVisible: false,
      socialVisible: false
    }
  },
  mounted() {
    // Animations
    setTimeout(() => {
      this.logoVisible = true;
    }, 500);
    
    setTimeout(() => {
      this.buttonVisible = true;
    }, 600);
    
    setTimeout(() => {
      this.socialVisible = true;
    }, 700);
  },
  methods: {
    goToShop() {
      this.$router.push('/shop');
    }
  }
}
</script>